export default {
  INTENT_VALIDATION_ERROR: 1002,
  LEASE_NOT_FOUND: 1007,
  RECORD_NOT_FOUND: 501,
  UNPROCESSABLE_ENTITY: 422,
}
